export const organizations = {
  background: {
    button: {
      country: '#f3f4f4',
      countryActive: '#66f0a0',
    },
  },
  color: {
    icon: {
      edit: '#004744',
    },
    buttonAdd: '#29aae1',
  },
}
